import { FILTER_TYPES } from 'components/FilterPod';

export const STATUS_BRANCH_OPTIONS = [
  {
    value: true,
    label: 'فعال',
  },

  {
    value: false,
    label: 'غیرفعال',
  },
];

const filters = (getCredit) => [
  {
    title: 'شماره شبا',
    label: 'شماره شبا',
    keyName: 'sheba',
    query: 'sheba',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'عنوان حساب',
    label: 'عنوان حساب',
    keyName: 'name',
    query: 'name',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
  },
];

export default filters;
